// NPM
import React, { Component } from 'react';
import PrivateActionButton from 'Components/Auth/PrivateActionButton';

class RecommendationActionButton extends Component {
  render() {
    const { className, onClick, children, ...otherProps } = this.props;
    return (
      <PrivateActionButton
        className={`RecommendationActionButton ${className}`}
        onClick={onClick}
        {...otherProps}
      >
        {children}
      </PrivateActionButton>
    );
  }
}

export default RecommendationActionButton;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationActionButton.js